import React, { useState, useEffect } from "react";
import {
  BarChart, Bar, XAxis, Tooltip, ResponsiveContainer,
  PieChart, Pie, Cell, LineChart, Line
} from "recharts";

const Analytics = () => {
  const [pendapatanData, setPendapatanData] = useState([]);
  const [pengeluaranData, setPengeluaranData] = useState([]);

  // 🔥 DATA 2026
  const pendapatanApi = {
    jan: 102666390 , feb: 0, mar: 0, apr: 0,
    mei: 0, jun: 0, jul: 0, agu: 0,
    sep: 0, okt: 0, nov: 0, des: 0
  };

  const pengeluaranApi = {
    jan: 51664764 , feb: 0, mar: 0, apr: 0,
    mei: 0, jun: 0, jul: 0, agu: 0,
    sep: 0, okt: 0, nov: 0, des: 0
  };

  const targetApi = {
    jan: 70000000, feb: 70000000, mar: 70000000, apr: 90000000,
    mei: 90000000, jun: 90000000, jul: 90000000, agu: 90000000,
    sep: 90000000, okt: 90000000, nov: 90000000, des: 90000000
  };

  const monthMap = [
    { key: "jan", label: "Jan" },
    { key: "feb", label: "Feb" },
    { key: "mar", label: "Mar" },
    { key: "apr", label: "Apr" },
    { key: "mei", label: "Mei" },
    { key: "jun", label: "Jun" },
    { key: "jul", label: "Jul" },
    { key: "agu", label: "Agu" },
    { key: "sep", label: "Sep" },
    { key: "okt", label: "Okt" },
    { key: "nov", label: "Nov" },
    { key: "des", label: "Des" }
  ];

  useEffect(() => {
    const formatted = monthMap.map((m) => ({
      name: m.label,
      Pendapatan: pendapatanApi[m.key] || 0,
      Target: targetApi[m.key] || 0
    }));

    const formattedPengeluaran = monthMap.map((m) => ({
      name: m.label,
      Pengeluaran: pengeluaranApi[m.key] || 0
    }));

    setPengeluaranData(formattedPengeluaran);
    setPendapatanData(formatted);
  }, []);

  // 🔥 TOTAL
  const totalPendapatan = pendapatanData.reduce((a, b) => a + b.Pendapatan, 0);
  const totalPengeluaran = pengeluaranData.reduce((a, b) => a + b.Pengeluaran, 0);
  const totalTarget = pendapatanData.reduce((a, b) => a + b.Target, 0);

  const achievement = totalTarget > 0
    ? ((totalPendapatan / totalTarget) * 100).toFixed(1)
    : 0;

  // 🔥 PIE (Target vs Realisasi)
  const pieData = [
    { name: "Realisasi", value: totalPendapatan },
    { name: "Sisa Target", value: totalTarget - totalPendapatan }
  ];

  const COLORS = ["#696cff", "#aeb3ff"];

  // KPI ICON
  const icons = ["bx bx-dollar", "bx bx-home", "bx bx-calendar", "bx bx-user"];
  const values = [totalPendapatan, totalPengeluaran, "0", "0"];
  const colors = ["#696cff", "#ff9f43", "#28c76f", "#ea5455"];

  return (
    <div className="container-xxl">
      <div className="row">

        {/* KPI CARDS */}
        {["Pendapatan", "Pengeluaran", "Pemesanan", "Tamu"].map((item, i) => (
          <div className="col-lg-3 col-md-6 mb-4" key={i}>
            <div className="card shadow-sm border-0" style={{ borderRadius: "16px" }}>
              <div className="card-body d-flex justify-content-between">
                <div>
                  <div style={{
                    background: `${colors[i]}15`,
                    padding: "10px",
                    borderRadius: "10px",
                    width: "fit-content"
                  }}>
                    <i className={icons[i]} style={{ color: colors[i] }}></i>
                  </div>
                  <small style={{ color: "#8592a3" }}>{item}</small>
                  <h4 style={{ color: "#566a7f" }}>
                    {i <= 1 ? `Rp ${values[i].toLocaleString("id-ID")}` : `${values[i]}`}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* MAIN CHART */}
        <div className="col-12 col-lg-8 mb-4">
          <div className="card shadow-sm border-0" style={{ borderRadius: "16px" }}>
            <div className="card-body">

              <div className="d-flex justify-content-between mb-3">
                <div>
                  <h5 style={{ color: "#566a7f" }}>Pendapatan 2026</h5>
                  <div className="d-flex align-items-center gap-3 mt-1">
                    <div className="d-flex align-items-center gap-1">
                        <span style={{ width: 10, height: 10, background: "#aeb3ff", borderRadius: "3px" }}></span>
                        <small style={{ color: "#8592a3" }}>Target</small>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                        <span style={{ width: 10, height: 10, background: "#696cff", borderRadius: "3px" }}></span>
                        <small style={{ color: "#8592a3" }}>Realisasi</small>
                    </div>
                  </div>
                </div>
                <h5 style={{ color: "#696cff" }}>{achievement}%</h5>
              </div>

              <ResponsiveContainer width="100%" height={200}>
                <BarChart data={pendapatanData} >
                  <XAxis dataKey="name" stroke="#a1acb8" axisLine={false} tickLine={false} />
                  <Tooltip formatter={(val) => `Rp ${val.toLocaleString("id-ID")}`} />
                  <Bar dataKey="Target" fill="#aeb3ff" radius={[8,8,8,8]} barSize={10} />
                  <Bar dataKey="Pendapatan" fill="#696cff" radius={[8,8,8,8]} barSize={10} />
                </BarChart>
              </ResponsiveContainer>

            </div>
          </div>
        </div>

        {/* PIE CHART */}
        <div className="col-12 col-lg-4 mb-4">
          <div className="card shadow-sm border-0" style={{ borderRadius: "16px" }}>
            <div className="card-body text-center">

              <h5 style={{ color: "#566a7f" }}>Pencapaian 2026</h5>

              <ResponsiveContainer width="100%" height={200}>
                <PieChart>
                  <Tooltip formatter={(val) => `Rp ${val.toLocaleString("id-ID")}`} />
                  <Pie data={pieData} dataKey="value" innerRadius={50} outerRadius={70}>
                    {pieData.map((entry, index) => (
                      <Cell key={index} fill={COLORS[index]} />
                    ))}
                  </Pie>

                  <text
                    x="50%" y="50%"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    style={{ fontSize: "16px", fontWeight: "600", fill: "#566a7f" }}
                  >
                    {achievement}%
                  </text>

                </PieChart>
              </ResponsiveContainer>

              <small style={{ color: "#aeb3ff" }}>
                Target:  Rp. {totalTarget.toLocaleString("id-ID")}
              </small> <br />
              <small style={{ color: "#696cff" }}>
                Realisasi: Rp. {totalPendapatan.toLocaleString("id-ID")}
              </small>

            </div>
          </div>
        </div>

        {/* SALES OVERVIEW */}
        <div className="col-12 col-lg-8 mb-4">
          <div className="card shadow-sm border-0" style={{ borderRadius: "16px" }}>
            <div className="card-body">
              <h5 style={{ color: "#566a7f" }}>Sales Overview</h5>
              <ResponsiveContainer width="100%" height={200}>
                <LineChart data={pendapatanData}>
                  <XAxis dataKey="name" stroke="#a1acb8"/>
                  <Tooltip formatter={(val) => `Rp ${val.toLocaleString("id-ID")}`} />
                  <Line type="monotone" dataKey="Pendapatan" stroke="#ff9f43" strokeWidth={3} dot={false}/>
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>

        {/* TOP PROPERTY */}
        <div className="col-12 col-lg-4 mb-4">
          <div className="card shadow-sm border-0" style={{ borderRadius: "16px" }}>
            <div className="card-body">
              <h5 style={{ color: "#566a7f" }}>Top Properties</h5>
              <ul className="list-group list-group-flush">
                <li className="list-group-item d-flex justify-content-between">
                  Villa A <span>Rp 120jt</span>
                </li>
                <li className="list-group-item d-flex justify-content-between">
                  Hotel B <span>Rp 98jt</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Analytics;